import React, { useState } from "react";
import Listcomp from './Listcomp';

const Todolistnew = () => {
    const [item, setItem] = useState();
    const [newitem, setNewItem] = useState([]);
    const itemEvent = (event) => {
        setItem(event.target.value);
    }
    const listofItems = () => {
        setNewItem((prevValue) => {
            return [...prevValue, item]
        })
        setItem('');
    }
    return <>
        <div className="row justify-content-center">
            <div className="col-md-4">
                <h2 className="text-center">TODO LIST New</h2>
                <div className="row g-3">
                    <div className="col-auto">
                        <input type="text" className="form-control" value={item} placeholder="Add a item" onChange={itemEvent} />
                    </div>

                    <div className="col-auto">
                        <button onClick={listofItems} className="btn btn-primary mb-3">+</button>
                    </div>
                </div>
                <hr />
                <ol>
                    {/* <li>{inputList}</li> */}
                    {newitem.map((itemval, index) => {
                        return < Listcomp
                            key={index}
                            id={index}
                            text={itemval}
                        />
                    })}
                </ol>
            </div>
        </div>
    </>
}
export default Todolistnew;